import { InterviewKind } from '@Domain/Enums/Interviews/InterviewKind';

export type InterviewDeletionTexts = {
	readonly header: string;
	/** What the deletion takes with it and what it leaves behind. */
	readonly baseMessage: string;
	/** Appended to `baseMessage` while a device is still sending the recording. */
	readonly uploadingMessage: string;
};

/** What deleting an interview takes with it, per kind. Shared by every dialog that deletes an interview. */
const interviewDeletionTexts: Readonly<Record<InterviewKind, InterviewDeletionTexts>> = Object.freeze({
	[InterviewKind.CONVERSATION]: {
		header: "Supprimer définitivement l'entretien",
		baseMessage:
			"Partiront avec lui : l'enregistrement audio, la transcription, les participants et le consentement. Les traitements restent, marqués « Entretien supprimé ».",
		uploadingMessage:
			'Un envoi de cet entretien est en cours depuis un appareil : son utilisateur sera averti.',
	},
	[InterviewKind.NOTES]: {
		header: 'Supprimer définitivement la prise de notes',
		baseMessage:
			"Partiront avec elle : l'enregistrement audio et la transcription. Les traitements restent, leur source marquée comme supprimée.",
		uploadingMessage:
			'Un envoi de cette prise de notes est en cours depuis un appareil : son utilisateur sera averti.',
	},
	[InterviewKind.TEXT]: {
		header: 'Supprimer définitivement le texte saisi',
		baseMessage:
			'Partira avec lui : sa transcription en tours. Les traitements restent, leur source marquée comme supprimée.',
		uploadingMessage:
			'Un envoi de ce texte est en cours depuis un appareil : son utilisateur sera averti.',
	},
});

export default interviewDeletionTexts;
